'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  p {\n    margin-bottom: 0;\n  }\n'], ['\n  p {\n    margin-bottom: 0;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _colors = require('HubStyleTokens/colors');

var _UIBreakString = require('UIComponents/text/UIBreakString');

var _UIBreakString2 = _interopRequireDefault(_UIBreakString);

var _clean = require('conversations-schema/sanitize/clean');

var _ChatWidgetLocaleContext = require('./ChatWidgetLocaleContext');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SmallNoParagraphPadding = (0, _styledComponents2.default)(_Small2.default).withConfig({
  displayName: 'ConsentPrompt__SmallNoParagraphPadding'
})(_templateObject);

var ConsentPrompt = function ConsentPrompt(_ref) {
  var message = _ref.message,
      onClick = _ref.onClick,
      showButton = _ref.showButton;
  return _react2.default.createElement(
    _UIFlex2.default,
    { align: 'center', justify: 'between', wrap: 'wrap', className: 'p-y-2 p-x-4' },
    _react2.default.createElement(
      _UIBreakString2.default,
      { className: 'm-bottom-0' },
      _react2.default.createElement(SmallNoParagraphPadding, {
        dangerouslySetInnerHTML: { __html: (0, _clean.clean)(message) },
        style: { color: _colors.FLINT }
      })
    ),
    showButton && _react2.default.createElement(
      _UIButton2.default,
      {
        onClick: onClick,
        style: { width: '100%' },
        className: 'm-bottom-2 m-top-3',
        use: 'tertiary',
        size: 'md'
      },
      _react2.default.createElement(
        _ChatWidgetLocaleContext.ChatWidgetLocaleContextConsumer,
        null,
        function (locale) {
          return _react2.default.createElement(_FormattedMessage2.default, {
            message: 'conversationsUI.buttons.agree',
            options: { locale: locale }
          });
        }
      )
    )
  );
};

ConsentPrompt.propTypes = {
  message: _react.PropTypes.string.isRequired,
  onClick: _react.PropTypes.func.isRequired,
  showButton: _react.PropTypes.bool.isRequired
};

exports.default = ConsentPrompt;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/ConsentPrompt.js
// module id = 1167
// module chunks = 2 3